module.exports = __webpack_public_path__ + "static/media/fp-logo.bf43a96a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fp-logo.svg
// module id = 484
// module chunks = 7